import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { HOW_STEPS, FAQS } from "@/lib/site-data";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import useSeo from "@/lib/useSeo";

export default function HowItWorks() {
  useSeo({
    title: "Nasıl Çalışır? | Epersonel",
    description:
      "Epersonel ile dijital satışa dört adımda başlayın: İşyerinizi tanıyalım, size özel plan hazırlayalım, kurulumu tamamlayalım ve operasyonu birlikte yönetelim.",
  });
  return (
    <>
      <section className="pt-16 pb-10">
        <div className="ep-container max-w-4xl">
          <p className="text-xs tracking-[0.3em] text-[#00F22E] font-medium mb-4">
            NASIL ÇALIŞIR?
          </p>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight">
            Dijital Satışa <span className="text-[#00F22E]">Dört Adımda</span>{" "}
            Başlayın
          </h1>
          <p className="mt-5 text-white/85 text-base md:text-lg leading-relaxed">
            İşyerinizi tanımaktan operasyonu yönetmeye kadar, sürecin her
            adımında yanınızdayız.
          </p>
        </div>
      </section>
      <section className="py-12">
        <div className="ep-container grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {HOW_STEPS.map((s, i) => (
            <div key={i} className="ep-card p-6" data-testid={`hiw-step-${i}`}>
              <div className="font-display text-4xl md:text-5xl font-extrabold text-[#00F22E] mb-3">
                {s.n}
              </div>
              <h3 className="font-display font-semibold text-lg">{s.title}</h3>
              <p className="mt-2 text-sm text-muted leading-relaxed">{s.copy}</p>
            </div>
          ))}
        </div>
        <div className="ep-container mt-10">
          <Link to="/basvuru" className="btn-primary" data-testid="hiw-cta">
            İlk Adımı Atın <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
      <section className="py-16">
        <div className="ep-container max-w-4xl">
          <h2 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight">
            Sık Sorulan Sorular
          </h2>
          <Accordion type="single" collapsible className="mt-10">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`hiw-faq-${i}`} className="border-white/[0.08]">
                <AccordionTrigger className="text-left font-display text-base md:text-lg font-medium hover:text-[#00F22E] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-muted leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </>
  );
}
